import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CeilPipe } from '../../../pipes/ceil.pipe';

interface IListProduct {
  id: number;
  name: string;
  name_es: string;
  description: string;
  image: string;
  provider_sku: string;
  price: string;
  surcharge: string;
  total: string;
  show_usa_user: boolean;
  show_mx_user: boolean;
  is_favorite?: boolean;
  categories?: {
    description: string;
    id: number;
    image: string;
    localizable_name: string; // "CATEGORY.MOBILE"
    name: string;
  }[];
  brand?: { id: number; name: string };
}

@Component({
  selector: 'product-list',
  standalone: true,
  imports: [TranslateModule, NzIconModule, NzButtonModule, CeilPipe],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss'
})
export class ProductListComponent {
  @Input() public products: IListProduct[];
  @Output() public toggleFavorite: EventEmitter<number>;
  @Output() public productClick: EventEmitter<IListProduct>;

  constructor(public translateService: TranslateService) {
    this.toggleFavorite = new EventEmitter<number>();
    this.productClick = new EventEmitter<IListProduct>();
  }

  public onToggleFavorite(product: IListProduct, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    product.is_favorite = !product.is_favorite;
    this.toggleFavorite.emit(product.id);
  }

  public onProductClick(product: IListProduct): void {
    this.productClick.emit(product);
  }
}
